function carouselize(e) {
  $(e).slick({
    lazyLoad: 'ondemand', 
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: false,
        nextArrow: false
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: false,
        nextArrow: false
      }
    }]
  });
}

function populateSubcollection(e, callbackFn) {
  var handle = $(e).data('handle');
  $.getJSON('/collections/' + handle + '/products.json', function(data) {
    
    
    // get up to 8 available products
    $(data.products).each(function(i, key) {
      
      // determine product availability
      let available = false;
      $.each(key.variants, function() {
        if (this.available) {
          available = true;
          return
        }
      });
            
      // if product is available, show it
      if (available) {

        // capture product tags
        var tags = key.tags;

        // capture savings flag
        var savings = Math.round(((key.variants[0].compare_at_price - key.variants[0].price) / key.variants[0].compare_at_price) * 100);
        var basementeer_savings = Math.round(((key.variants[0].compare_at_price - (key.variants[0].price * 0.9)) / key.variants[0].compare_at_price) * 100);

        if (savings >= 5) { 
          var flag_savings = '<span class="product-flag h6 savings"></span>';
          if (tags.includes('nodiscount' ) || tags.includes('hidediscount') || tags.includes('NPISO')) { 
            var price_savings = '<span class="product-savings"><small>You Save ' + savings + '%</small></span>';
          } else {
            var price_savings = '<span class="product-savings"><small>You Save ' + savings + '%<p><span style="font-weight: 400;">Basementeers save ' +  basementeer_savings + '%</span></p></small></span>';
          }
        } else {
          var flag_savings = '';
          var price_savings = '';
        }

        // capture staff pick flag 
        if (key.tags.includes('Staff Pick')) { var flag_staff_pick = '<span class="product-flag h6 staff-pick">Staff Pick</span>'; } else { var flag_staff_pick = ''; }

        // capture rental flag 
        if (key.tags.includes('Rental')) { var flag_rental = '<span class="product-flag h6 rental">Rental</span>'; } else { var flag_rental = ''; }

        $(e).append(`<div><div class="mb-3 px-2" style="width: 100%; display: inline-block; position: relative;"><div class="product-flags">${flag_savings}${flag_staff_pick}${flag_rental}</div><div class="product-item" data-threshold="1"><div class="p-3"><a href="/collections/camp-hike/products/${key.handle}" title="${key.title}" aria-label="${key.title}" tabindex="0"><img alt="${key.title}" style="opacity: 1;" src="${key.images[0].src}"></a></div><div class="p-3"><a href="/collections/camp-hike/products/${key.handle}" aria-label="${key.title}" ><span class="product-vendor">${key.vendor}</span><br><span class="product-title">${key.title}</span><br><span class="product-price">$${key.variants[0].price}</span><br> ${price_savings}<br></a></div></div></div></div>`);
        if (i > 7) { 
          return false
        }
        
      }
      
    });
    
    callbackFn(e);

  });
}

$( document ).ready(function() {
  $('.subcollection .products').each(function() {
    populateSubcollection(this, carouselize);
  });
});
